export const getSeason = (seasons, date) => {
    const timeStamp = Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
    );
    if (seasons) {
        let season = seasons[0];
        for (var i = 1; i < seasons.length; i++) {
            if (
                seasons[i].period.from_timestamp <= timeStamp &&
                seasons[i].period.to_timestamp >= timeStamp
            ) {
                season = seasons[i];
                break;
            }
        }
        return season;
    }
};
